module.exports = __webpack_public_path__ + "static/img/win_prize.ffb2725.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/1314/win_prize.png
// module id = 479
// module chunks = 1